import { HStack, IconButton } from "@chakra-ui/react";
import { colors } from "@/components/Theme/colors";
import { FC } from "react";
import { Ico } from "@/assets/icons";
import { Channel, SocialPlatform } from "@/schemaTypes";
import { Link } from "react-router-dom";

interface ChannelSocialIconsProps {
  social: Channel["social"];
}

const getSocialIcon = (type: SocialPlatform) => {
  switch (type) {
    case SocialPlatform.Facebook:
      return <Ico.Facebook />;
    case SocialPlatform.Linkedin:
      return <Ico.LinkedIn />;
    case SocialPlatform.Instagram:
      return <Ico.Instagram />;
    case SocialPlatform.Youtube:
      return <Ico.YouTube />;
    case SocialPlatform.Other:
      return <Ico.Globe />;
  }
};

const ChannelSocialIcons: FC<ChannelSocialIconsProps> = ({ social }) => (
  <HStack spacing={2} justifyContent={{ base: "center", md: "flex-start" }}>
    {social.map((s, i) => (
      <Link key={i} to={s.url} target="_blank" rel="noopener noreferrer">
        <IconButton
          icon={getSocialIcon(s.platform)}
          aria-label="social"
          variant="ghost"
          fontSize="22px"
          color={colors.secondary[300]}
        />
      </Link>
    ))}
  </HStack>
);

export default ChannelSocialIcons;
